module.exports = __webpack_public_path__ + "static/media/add-time.d6fd2579.svg";